// ─────────────────────────────────────────────────────────────────────────────
// Location Shipping Exclusions Actions
// ─────────────────────────────────────────────────────────────────────────────
// NgRx actions for the locationShippingExclusions store slice (WB-7570).
// Flat, unpaginated list: Load, Create, Delete (keyed by location_id).
// ─────────────────────────────────────────────────────────────────────────────

import { createAction, props } from '@ngrx/store';
import { APIResponse } from 'src/app/core/models/api-response';
import { ICreateLocationShippingExclusionPayload, ILocationShippingExclusion } from '../models/location-shipping-exclusion.models';

// ── Load ─────────────────────────────────────────────────────────────────────

export const LoadLocationShippingExclusions = createAction('[ LocationShippingExclusions ] - Load');
export const LoadLocationShippingExclusionsSuccess = createAction(
  '[ LocationShippingExclusions ] - Load Success',
  props<{ response: APIResponse<ILocationShippingExclusion> }>(),
);
export const LoadLocationShippingExclusionsError = createAction('[ LocationShippingExclusions ] - Load Error', props<{ error: string }>());

// ── Create ───────────────────────────────────────────────────────────────────

export const CreateLocationShippingExclusion = createAction(
  '[ LocationShippingExclusions ] - Create',
  props<{ payload: ICreateLocationShippingExclusionPayload }>(),
);
export const CreateLocationShippingExclusionSuccess = createAction(
  '[ LocationShippingExclusions ] - Create Success',
  props<{ exclusion: ILocationShippingExclusion }>(),
);
export const CreateLocationShippingExclusionError = createAction('[ LocationShippingExclusions ] - Create Error', props<{ error: string }>());

// ── Bulk create (one POST for the whole batch, idempotent per id --
//    a duplicate/already-excluded/invalid id is skipped rather than
//    failing the whole batch) ─────────────────────────────────────────────

export const BulkCreateLocationShippingExclusions = createAction(
  '[ LocationShippingExclusions ] - BulkCreate',
  props<{ locationIds: number[] }>(),
);
export const BulkCreateLocationShippingExclusionsSuccess = createAction(
  '[ LocationShippingExclusions ] - BulkCreate Success',
  props<{ created: ILocationShippingExclusion[]; skipped: number }>(),
);
export const BulkCreateLocationShippingExclusionsError = createAction(
  '[ LocationShippingExclusions ] - BulkCreate Error',
  props<{ error: string }>(),
);

// ── Delete (keyed by location_id) ─────────────────────────────────────────────

export const DeleteLocationShippingExclusion = createAction('[ LocationShippingExclusions ] - Delete', props<{ locationId: number }>());
export const DeleteLocationShippingExclusionSuccess = createAction(
  '[ LocationShippingExclusions ] - Delete Success',
  props<{ locationId: number }>(),
);
export const DeleteLocationShippingExclusionError = createAction('[ LocationShippingExclusions ] - Delete Error', props<{ error: string }>());

// ── Bulk delete (one DELETE for the whole batch, idempotent per id --
//    an id not on the list is skipped rather than failing the whole
//    batch, same as bulk create) ──────────────────────────────────────────

export const BulkDeleteLocationShippingExclusions = createAction(
  '[ LocationShippingExclusions ] - BulkDelete',
  props<{ locationIds: number[] }>(),
);
export const BulkDeleteLocationShippingExclusionsSuccess = createAction(
  '[ LocationShippingExclusions ] - BulkDelete Success',
  props<{ deleted: number[]; skipped: number }>(),
);
export const BulkDeleteLocationShippingExclusionsError = createAction(
  '[ LocationShippingExclusions ] - BulkDelete Error',
  props<{ error: string }>(),
);
